import { useContext } from 'react';

import { EmbeddedWebpageContext } from '@/shared/components/embedded/EmbeddedWebpageContext';

export const useEmbeddedWebpageContext = () =>
  useContext(EmbeddedWebpageContext);
